import React from 'react';
import Header from '../components/Cattle-feed/Header';
import ListItem from '../components/ListItem';
import { data } from '../HorseData/ProductsForHorses';
import Footer from '../components/Cattle-feed/Footer';

export default function HorseList() {
  return (
    <div id="wrapperParallax" className="wrapper wrapper-boxed clearfix">
      <Header />
      {data
        .filter(i => i.type === 'horse')
        .map(data => {
          return (
            <ListItem
              name={data.name || 'No Name'}
              description={data.description || 'No Description'}
              ingredientValues={data.ingredientValues || 'No Ingredient Values'}
              image={data.image}
              id={data.id}
            />
          );
        })}
      <Footer />
    </div>
  );
}
